import { config } from 'env_def';
import { apis, inWindow } from '@/config';
import { api } from '@/api/api';
import { util } from '@/api/util';
const forElectron = config('build_for') === 'electron';
class KfApiImp {
    constructor() {
        this.isInited = false;
        this.isReady = false;
        this.waitList = [];
        this.version = config('version');
        this.name = apis.kfApiImpl;
        this.eventApi = api.getEventApi();
        this.systemApi = api.getSystemApi();
        this.storeApi = api.getDataStoreApi();
    }
    getEmail() {
        const user = this.systemApi.getCurrentUser();
        return user === null || user === void 0 ? void 0 : user.id;
    }
    setKfConfig(callback) {
        if (this.isReady) {
            const userId = this.getEmail();
            if (userId) {
                this.loginHandle(res => {
                    callback && callback(res);
                    if (this.waitList.length) {
                        this.waitList.forEach(fn => fn(res));
                    }
                });
            }
            else {
                KfApiImp.logoutHandle();
            }
        }
        else {
            callback && this.waitList.push(callback);
        }
    }
    loginHandle(callback) {
        var _a, _b;
        const user = this.systemApi.getCurrentUser();
        const uid = (_a = user.contact) === null || _a === void 0 ? void 0 : _a.contact.id;
        const avatar = (_b = user.contact) === null || _b === void 0 ? void 0 : _b.contact.avatar;
        const EDM_QI_YU_CONFIG = forElectron
            ? { referrer: 'https://khd.waimao.office.163.com/khd', title: '外贸通客户端' }
            : { referrer: 'https://wangye.website.waimao.office.163.com/wangye', title: '外贸通网页端' };
        const LINGXI_QI_YU_CONFIG = forElectron ? { referrer: 'sirius-desktop', title: '网易灵犀办公桌面端' } : { referrer: 'sirius-web', title: '网易灵犀办公网页' };
        const QI_YU_CONFIG = process.env.BUILD_ISEDM ? EDM_QI_YU_CONFIG : LINGXI_QI_YU_CONFIG;
        const options = {
            uid,
            email: user.id,
            name: user.nickName,
            groupid: '480959804',
            robotShuntSwitch: 1,
            robotId: 9091,
            qtype: 4483243,
            welcomeTemplateId: 1151,
            title: QI_YU_CONFIG.title,
            referrer: QI_YU_CONFIG.referrer,
            data: JSON.stringify([
                { key: 'avatar', label: '头像', value: avatar },
                { key: 'version', label: '版本号', value: this.version },
                { key: 'system', label: '系统', value: util.isMac() ? 'MacOS' : 'Windows' },
            ]),
            success: () => {
                callback && callback(true);
                console.log('[kf_impl] config set success', options);
            },
            error: e => {
                callback && callback(false);
                console.error('[kf_impl] config set error', e);
            },
        };
        window.ysf('config', options);
    }
    static logoutHandle() {
        window.ysf('logoff');
    }
    async getUrl() {
        return new Promise((r, j) => {
            if (this.isReady) {
                const url = window.ysf('url', {
                    templateId: 6603268,
                });
                r(url);
            }
            else {
                this.setKfConfig(success => {
                    if (success) {
                        const url = window.ysf('url', {
                            templateId: 6603268,
                        });
                        r(url);
                    }
                    else {
                        j();
                    }
                });
            }
        });
    }
    openUrl() {
        const url = window.ysf('url', {
            templateId: 6603268,
        });
        this.systemApi.openNewWindow(url, false);
    }
    init() {
        return this.name;
    }
    afterInit() {
        console.warn('[kf_impl] window.kf', window.ysf);
        if (inWindow() && window.ysf && !this.isInited) {
            this.isInited = true;
            window.ysf('onready', () => {
                this.isReady = true;
                this.setKfConfig();
            });
            this.eventApi.registerSysEventObserver('updateUserInfo', {
                func: () => {
                    this.loginHandle();
                },
            });
        }
        return this.name;
    }
    afterLogin() {
        return this.name;
    }
    beforeLogout() {
        return this.name;
    }
}
KfApiImp.keyDeviceUUID = config('browerDeviceUUID');
const impl = new KfApiImp();
api.registerLogicalApi(impl);
export default impl;
